import { useEffect, useState } from 'react'
import supabase from '../../../lib/supabase'
import { Actions, Area, Row, Select, TwoColumn, clean } from './EditorFields'

const blank = { partner_id: '', relation_type: 'accountant_referrer', is_primary: true, notes: '' }

export default function ClientPartnersEditor({ client, partners, onChanged }) {
  const [rows, setRows] = useState([])
  const [form, setForm] = useState(blank)
  const [id, setId] = useState(null)
  const [saving, setSaving] = useState(false)
  const set = (key, value) => setForm((current) => ({ ...current, [key]: value }))

  useEffect(() => { load() }, [client.id])
  async function load() { const { data, error } = await supabase.from('codevaro_client_partners').select('*').eq('client_id', client.id); if (error) return alert(error.message); setRows(data || []) }
  function edit(row) { setId(row.id); setForm({ ...blank, ...row }) }
  function reset() { setId(null); setForm(blank) }
  async function save(event) {
    event.preventDefault(); if (!form.partner_id) return
    setSaving(true)
    const payload = clean({ ...form, client_id: client.id })
    const result = id ? await supabase.from('codevaro_client_partners').update(payload).eq('id', id) : await supabase.from('codevaro_client_partners').insert(payload)
    setSaving(false); if (result.error) return alert(result.error.message)
    reset(); await load(); if (onChanged) await onChanged()
  }

  return <TwoColumn title="Partners / accountants" rows={rows} renderRow={(row) => { const partner = partners.find((x) => x.id === row.partner_id); return <Row key={row.id} title={partner?.name || 'Partner'} subtitle={[partner?.company_name,row.relation_type,row.is_primary ? 'Primary' : ''].filter(Boolean).join(' · ')} onEdit={() => edit(row)} /> }}>
    <form onSubmit={save} className="grid gap-3">
      <Select label="Partner *" value={form.partner_id} onChange={(v) => set('partner_id', v)}><option value="">Select partner</option>{partners.map((partner) => <option key={partner.id} value={partner.id}>{partner.name}{partner.company_name ? ` — ${partner.company_name}` : ''}</option>)}</Select>
      <Select label="Relationship" value={form.relation_type} onChange={(v) => set('relation_type', v)}><option value="accountant_referrer">Accountant / referrer</option><option value="accountant">Accountant</option><option value="referrer">Referrer</option><option value="technology_partner">Technology partner</option><option value="other">Other</option></Select>
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={!!form.is_primary} onChange={(e) => set('is_primary', e.target.checked)} /> Primary partner for this client</label>
      <Area label="Notes" value={form.notes} onChange={(v) => set('notes', v)} />
      <Actions saving={saving} editing={!!id} reset={reset} />
    </form>
  </TwoColumn>
}